import React from 'react';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Panel,
  Checkbox,
  Row,
  Clearfix
} from "react-bootstrap";

import { educationalGoalOptions, statusTypes } from "../config/constants";

const EducationInfoStatic = (props) => {
  const {
    hsName,
    hsGpa,
    hsDiploma,
    hsGed,
    hsForeignDiploma,
    colleges,
    collegeMajor,
    collegeUnits,
    degrees
  } = props;

  const renderColleges = () => {
    if(colleges.length === 0) {
      return (
        <p>
          No colleges listed
        </p>
      )
    }

    return colleges.map((college, index) => {
      return (
        <FormGroup
          key={college.id}
          controlId={`college-${college.id}-name`}>
          <ControlLabel>
            College {index + 1}
          </ControlLabel>
          <FormControl.Static>
            {college.name}
          </FormControl.Static>
        </FormGroup>
      );
    });
  };

  const renderDegrees = () => {
    if (degrees.length === 0) {
      return (
        <p>
          No degrees listed
        </p>
      );
    }

    return degrees.map((degree, index) => {
      return (
        <FormGroup
          key={degree.id}
          controlId={`degree-${degree.id}-name`}>
          <ControlLabel>
            Degree {index + 1}
          </ControlLabel>
          <FormControl.Static>
            {degree.name}
          </FormControl.Static>
        </FormGroup>
      );
    });
  };

  return (
    <Panel bsStyle={statusTypes.INFO}>
      <Panel.Heading>Education Information</Panel.Heading>
      <Panel.Body>
        <h4>High School</h4>
        <Row>
          <Col md={6}> {/* High School Name */}
            <FormGroup controlId='high-school-name'>
              <ControlLabel>
                High School Name
              </ControlLabel>
              <FormControl.Static>
                {hsName}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={2}> {/* High School GPA */}
            <FormGroup controlId='high-school-gpa'>
              <ControlLabel>
                High School GPA
              </ControlLabel>
              <FormControl.Static>
                {hsGpa}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={4}>
            <Checkbox
              name='hsDiploma'
              checked={hsDiploma}
              readOnly
            >
              High School Diploma
            </Checkbox>
            <Checkbox
              name='hsGed'
              checked={hsGed}
              readOnly
            >
              High School GED
            </Checkbox>
            <Checkbox
              name='hsForeignDiploma'
              checked={hsForeignDiploma}
              readOnly
            >
              Foreign High School Diploma
            </Checkbox>
          </Col>
        </Row>
        <hr />
        <h4>College</h4>
        <FormGroup controlId='educational-goal'>
          <ControlLabel>
            Educational Goal
          </ControlLabel>
          <Row>
            {educationalGoalOptions.map((option, index) => {
              return (
                <Col sm={3} md={2} key={index}>
                  <Checkbox
                    inline
                    checked={props[option.value]}
                    readOnly
                  >
                    {option.text}
                  </Checkbox>
                </Col>
              )
            })
            }
          </Row>
        </FormGroup>
        <Row>
          <Col md={6}>
            <FormGroup controlId='college-major'>
              <ControlLabel>
                College Major
              </ControlLabel>
              <FormControl.Static>
                {collegeMajor}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}> {/* College Units */}
            <FormGroup controlId='college-units'>
              <ControlLabel>
                Total College Units Completed
              </ControlLabel>
              <FormControl.Static>
                {collegeUnits}
              </FormControl.Static>
            </FormGroup>
          </Col> {/* College Units */}
        </Row>
        <Row>
          <Col lg={6}>
            <h4>Other Colleges</h4>
            {renderColleges()}
          </Col>
          <Clearfix visibleMdBlock visibleSmBlock visibleXsBlock />
          <Col lg={6}>
            <h4>Degrees</h4>
            {renderDegrees()}
          </Col>
        </Row>
      </Panel.Body>
    </Panel>
  )
};

export default EducationInfoStatic